import type { InsolvencyPoolCheck } from "@gearbox-protocol/deploy-tools-shared";
import { AddressView, TokenAmount } from "@gearbox-protocol/deploy-tools-ui";
import clsx from "clsx";
import type { FC } from "react";

interface PoolInsolvencyCardProps {
  pool: InsolvencyPoolCheck;
}

const PoolInsolvencyCard: FC<PoolInsolvencyCardProps> = ({ pool }) => {
  const {
    pool: address,
    name,
    symbol,
    decimals,
    insolvent,
    expectedLiquidity,
    realLiquidity,
    tvl,
  } = pool;
  const diff = realLiquidity - expectedLiquidity;
  return (
    <div
      id={address.toLowerCase()}
      className={clsx("border border-gray-50 rounded-xl mt-4 py-4", {
        "bg-red-950": insolvent,
        "bg-green-950": !insolvent,
      })}
    >
      <div>
        <div className="flex flex-row items-center justify-between mx-4">
          <div className="flex flex-row items-center gap-2">
            <h2 className="w-[300px]">{name}</h2>

            <AddressView
              compact
              address={address}
              className="border border-1 border-gray-50 p-1 text-sm rounded-md opacity-70"
            />
          </div>
        </div>
      </div>

      <div className="px-2">
        <div className="grid grid-cols-values-2 mt-4 border border-border">
          <div className="w-64 font-bold p-2 border-b border-r">
            Expected Liquidity
          </div>
          <div className="flex flex-row items-center p-2 gap-x-2 border-b ">
            <TokenAmount
              value={{ amount: expectedLiquidity, decimals, symbol }}
              raw={expectedLiquidity}
            />
          </div>

          <div className="w-64 font-bold p-2 border-b border-r">
            Real Liquidity
          </div>
          <div className="flex flex-row items-center p-2 gap-x-2 border-b ">
            <TokenAmount
              value={{ amount: realLiquidity, decimals, symbol }}
              raw={realLiquidity}
            />
          </div>

          <div className="w-64 font-bold p-2 border-b border-r">Diff</div>
          <div className="flex flex-row items-center p-2 gap-x-2 border-b ">
            <TokenAmount
              value={{ amount: diff, decimals, symbol }}
              raw={diff}
            />
          </div>

          <div className="w-64 font-bold p-2 border-r">TVL</div>
          <div className="flex flex-row items-center p-2 gap-x-2">
            <TokenAmount value={{ amount: tvl, decimals, symbol }} raw={tvl} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoolInsolvencyCard;
